import { useEffect } from 'react';
import { setEnv as fpSetEnv, Environment } from '@chegg/fingerprint-web-sdk';
export function useSetFpEnv() {
  useEffect(function () {
    fpSetEnv(process.env.CHEGG_ENV === Environment.prod ? Environment.prod : Environment.test);
  }, []);
}